import styled, { css } from 'styled-components';
import ReactInputMask from 'react-input-mask';
import ReactCurrencyInputField from 'react-currency-input-field';
import { ColorAddiFontStrong, ColorAddiFontHint, ColorAddiFontSecondary, ColorAddiFontError, ColorAddiFontPrimary, ColorAddiCompFiveBase, ColorAddiCompTwoDarken2, ColorAddiCompTwoDarken1, } from '@addi/foundation/dist/web/colors';
import { FontAddiWeightRegular, FontAddiFamilySecondaryName, FontAddiWeightBold, FontAddiWeightMedium, } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontSmall } from '@addi/foundation/dist/web/sizes';
import { Label } from '../typographies';
export var TEXT_ALIGN;
(function (TEXT_ALIGN) {
    TEXT_ALIGN["left"] = "left";
    TEXT_ALIGN["right"] = "right";
    TEXT_ALIGN["center"] = "center";
})(TEXT_ALIGN || (TEXT_ALIGN = {}));
const OUTSIDE_HINT_INPUT_SPACE = '1.313rem';
const OUTSIDE_LABEL_INPUT_SPACE = '-1.313rem';
export const LabelTxt = styled.span `
  position: relative;
`;
export const Prefix = styled.span `
  color: ${ColorAddiFontPrimary};
  display: inline-block;
  position: absolute;
  z-index: 0;
  top: 5px;
  left: 0;
  width: 1.2rem;
`;
export const TxtPrefix = styled(Prefix) `
  font-size: ${SizeAddiFontSmall};
  line-height: 1.8rem;
  text-align: center;
  font-family: ${FontAddiFamilySecondaryName};
  font-weight: ${FontAddiWeightBold};
  color: ${ColorAddiFontSecondary};
  margin-left: 1rem;
  top: 0.43rem;
  margin: 0 0 0 0.7rem;
  height: 1.4rem;
`;
export const TextPrefixWithSpacing = styled(Prefix) `
  font-size: ${SizeAddiFontSmall};
  line-height: 1.8rem;
  text-align: center;
  font-family: ${FontAddiFamilySecondaryName};
  font-weight: ${FontAddiWeightBold};
  color: ${ColorAddiFontSecondary};
  top: 0.43rem;
  margin: 0 0 0 0.7rem;
  height: 1.4rem;
`;
export const IconPrefix = styled(Prefix) `
  height: 1.3rem;
  margin: 0.3rem 0.1rem 0.3rem 0.25rem;
  text-align: center;
  font-weight: ${FontAddiWeightBold};
  & > svg {
    height: 1.2rem;
    color: ${ColorAddiFontSecondary};
  }
`;
export const IconSubfix = styled(Prefix) `
  height: 1.3rem;
  margin: 0.3rem 0.1rem;
  text-align: center;
  font-weight: ${FontAddiWeightBold};
  right: 0.25rem;
  left: initial;
  & > svg {
    height: 1.2rem;
    color: ${ColorAddiFontSecondary};
  }
`;
export const InputLabel = styled(Label) `
  position: absolute;
  left: 0;
  top: ${OUTSIDE_LABEL_INPUT_SPACE};
  padding: 0;
  pointer-events: none;
  letter-spacing: 0.02rem;
  line-height: 17px;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    top: 10px;
    left: 0;
    z-index: 0;
  }
`;
export const input = css `
  width: 100%;
  height: 100%;
  padding: 0.5rem 1rem 0.5rem 1rem;
  border: 1px solid #a7b2bb;
  border-radius: 0.75rem;
  background: transparent;
  box-sizing: border-box;
  color: ${ColorAddiFontPrimary};
  letter-spacing: 0.02rem;
  font-size: ${SizeAddiFontSmall};
  line-height: 21px;
  font-family: ${FontAddiFamilySecondaryName};
  font-weight: ${FontAddiWeightRegular};

  &:disabled {
    color: ${ColorAddiFontSecondary};
    background: #eff3f7;

    & + ${Label} {
      color: ${ColorAddiFontStrong};
    }
  }

  &:focus {
    outline: none;
    border-width: 2px;
    border-color: ${ColorAddiCompFiveBase};

    &::before {
      border-width: 2px;
    }
  }

  &::placeholder {
    color: ${ColorAddiFontHint};
  }

  /* Chrome, Safari, Edge, Opera */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
export const Input = styled.input `
  ${input}
  padding-left: ${(props) => (props.$withPrefix && 3) || (props.$withIconPrefix && 1.5) || 1}rem;
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : 'left')};
`;
export const InputWithMask = styled(ReactInputMask) `
  ${input}
  padding-left: ${(props) => (props.$withPrefix ? 2.7 : 1)}rem;
  text-align: ${(props) => (props.$textAlign ? props.$textAlign : 'left')};
`;
export const TextArea = styled.textarea `
  ${input}
  text-align: ${(props) => (props.textAlign ? props.textAlign : 'left')};
  min-height: 220px;
`;
export const InputContainer = styled.div `
  width: 100%;
  height: 2.5rem;
  position: relative;
  ${(props) => !props.error && props.warn
    ? css `
          ${Input} {
            border: 1px solid ${ColorAddiCompTwoDarken1};
          }

          ${InputWithMask} {
            border: 1px solid ${ColorAddiCompTwoDarken1};
          }
        `
    : props.error &&
        css `
          ${Input} {
            border: 1px solid ${ColorAddiFontError};
          }

          ${InputWithMask} {
            border: 1px solid ${ColorAddiFontError};
          }
        `}
`;
export const Container = styled.div `
  display: inline-block;
  width: ${(props) => (props.width ? props.width : '220px')};
  font-family: ${FontAddiFamilySecondaryName};
  font-size: ${SizeAddiFontSmall};
  line-height: 21px;
  font-weight: ${FontAddiWeightMedium};
  margin-top: ${OUTSIDE_HINT_INPUT_SPACE};
  margin-bottom: ${OUTSIDE_HINT_INPUT_SPACE};
  position: relative;
`;
export const Helpers = styled.div `
  position: absolute;
`;
export const Hint = styled(Label) `
  line-height: 14px;
  margin: 0;
  color: ${ColorAddiFontHint};
  width: 100%;
  padding: 0;
`;
export const Warn = styled(Label) `
  line-height: 14px;
  margin: 0;
  color: ${ColorAddiCompTwoDarken2};
  width: 100%;
  padding: 0;
`;
export const Error = styled(Hint) `
  color: ${ColorAddiFontError};
`;
export const StoryDiv = styled.div `
  margin: 30px;
`;
export const CurrencyInputField = styled(ReactCurrencyInputField) `
  ${input};
  padding-left: ${(props) => (props.$withPrefix && 2.2) || (props.$withIconPrefix && 1.5) || 1}rem;
`;
//# sourceMappingURL=text-input-v2.styled.js.map